import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react"
import { Button } from "ui/@button"
import { walletIcon } from "assets/icons"
import styles from "./index.module.scss"

interface IButtonWalletV2 {}

export const ButtonWalletV2: FC<IButtonWalletV2> = () => {
  const { t } = useTranslation()
  const [tonConnectUI] = useTonConnectUI()
  const tonAddress = useTonAddress()

  if (tonAddress)
    return (
      <Button
        className={clsx(styles.ButtonWallet, styles.disconnect)}
        onClick={() => tonConnectUI.disconnect()}
      >
        {t("Disconnect Wallet")} <img src={walletIcon} />
      </Button>
    )

  return (
    <Button
      className={clsx(styles.ButtonWallet, styles.connect)}
      onClick={() => tonConnectUI.openModal()}
    >
      {t("Connect Wallet")} <img src={walletIcon} />
    </Button>
  )
}
